import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SmIcon = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": "true",
  width: "1rem",
  height: "1rem",
  ...props,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M3 7H1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2",
    opacity: 0.45
  }), /*#__PURE__*/_jsx("path", {
    d: "M15 7h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7 13v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0",
    opacity: 0.3
  }), /*#__PURE__*/_jsx("path", {
    d: "M7 1v2a1 1 0 0 0 2 0V1a1 1 0 0 0-2 0",
    opacity: 0.65
  }), /*#__PURE__*/_jsx("path", {
    d: "m9.634 12.83 1 1.732a1 1 0 1 0 1.732-1l-1-1.732a1 1 0 0 0-1.732 1",
    opacity: 0.25
  }), /*#__PURE__*/_jsx("path", {
    d: "m3.634 2.438 1 1.732a1 1 0 1 0 1.732-1l-1-1.732a1 1 0 1 0-1.732 1",
    opacity: 0.55
  }), /*#__PURE__*/_jsx("path", {
    d: "m11.83 11.366 1.732 1a1 1 0 1 0 1-1.732l-1.732-1a1 1 0 1 0-1 1.732",
    opacity: 0.2
  }), /*#__PURE__*/_jsx("path", {
    d: "m1.438 5.366 1.732 1a1 1 0 1 0 1-1.732l-1.732-1a1 1 0 1 0-1 1.732",
    opacity: 0.5
  }), /*#__PURE__*/_jsx("path", {
    d: "m12.83 6.366 1.732-1a1 1 0 0 0-1-1.732l-1.732 1a1 1 0 0 0 1 1.732",
    opacity: 0.85
  }), /*#__PURE__*/_jsx("path", {
    d: "m2.438 12.366 1.732-1a1 1 0 1 0-1-1.732l-1.732 1a1 1 0 1 0 1 1.732",
    opacity: 0.4
  }), /*#__PURE__*/_jsx("path", {
    d: "m11.366 4.17 1-1.732a1 1 0 0 0-1.732-1l-1 1.732a1 1 0 0 0 1.732 1",
    opacity: 0.75
  }), /*#__PURE__*/_jsx("path", {
    d: "m5.366 14.562 1-1.732a1 1 0 1 0-1.732-1l-1 1.732a1 1 0 0 0 1.732 1",
    opacity: 0.35
  })]
});
export default SmIcon;